{
  "approval": {
    "title": "Approvals",
    "subtitle": "Review and approve or reject pending publishers",
    "pendingCount": "{{count}} publisher(s) pending approval",
    "emptyTitle": "No pending approvals",
    "emptyDesc": "All registered publishers have been reviewed",
    "loadError": "Failed to load publishers list",
    "loadMore": "Load more",
    "fields": {
      "publisher": "Publisher",
      "country": "Country",
      "registeredAt": "Registered",
      "actions": "Actions",
      "status": "Status"
    },
    "actions": {
      "approve": "Approve",
      "reject": "Reject",
      "view": "View details",
      "restore": "Restore"
    },
    "approveSuccess": "Publisher approved successfully",
    "approveError": "Failed to approve publisher",
    "rejectSuccess": "Publisher rejected successfully",
    "rejectError": "Failed to reject publisher",
    "retry": "Retry",
    "statusError": "Failed to update status",
    "emptyWaiting": "No publishers awaiting approval",
    "emptyRejected": "No rejected publishers",
    "emptyAccepted": "No approved publishers",
    "emptySuspended": "No suspended publishers",
    "status": {
      "waiting": "Awaiting Review",
      "rejected": "Rejected",
      "accepted": "Approved"
    }
  },
  "adminTitles": {
    "title": "All Titles",
    "subtitle": "Manage and review all book titles on the platform",
    "sectionLabel": "Management",
    "searchPlaceholder": "Search titles, authors, ISBN…",
    "footerLabel": "titles",
    "export": "Export",
    "addTitle": "Add Title",
    "allOrganizations": "All Organizations",
    "tabs": {
      "all": "All",
      "published": "Published",
      "pending": "Pending",
      "editing": "Editing",
      "suspended": "Suspended",
      "revisions": "Revision Review"
    },
    "columns": {
      "title": "Title",
      "author": "Author",
      "publisher": "Publisher",
      "status": "Status",
      "dateAdded": "Date Added"
    },
    "toast": {
      "approveSuccess": "Title approved",
      "suspendSuccess": "Title suspended",
      "reactivateSuccess": "Title reactivated",
      "statusError": "Failed to update title status",
      "activateSuccess": "Title activated",
      "deactivateSuccess": "Title deactivated",
      "billingError": "Failed to update title activation"
    }
  },
  "revisionReview": {
    "queueSub": "Edits submitted by publishers on already-approved titles. Review each change before it goes live.",
    "submittedBy": "Submitted by",
    "reviewBtn": "Review changes",
    "footerLabel": "titles awaiting review",
    "empty": {
      "title": "No revisions to review",
      "desc": "Publisher edits awaiting review will appear here."
    },
    "columns": {
      "changes": "Changes",
      "submitted": "Submitted"
    },
    "changes": "changes",
    "files": "files",
    "needsAttention": "needs attention",
    "fieldsChanged": "fields changed",
    "filesReplaced": "files replaced",
    "loadError": "Failed to load this revision",
    "retry": "Retry",
    "back": "Back to queue",
    "statusReview": "Approved · changes under review",
    "submitted": "Submitted",
    "viewMode": "View mode",
    "viewSplit": "Side by side",
    "viewInline": "Inline",
    "current": "Current",
    "currentSub": "Approved · live",
    "proposed": "Proposed",
    "proposedSub": "by publisher",
    "was": "Was",
    "now": "Now",
    "validated": "Validated",
    "invalid": "Validation failed",
    "showUnchanged": "Show unchanged fields",
    "hideUnchanged": "Hide unchanged fields",
    "approveBtn": "Approve changes",
    "approvedBtn": "Approved",
    "rejectBtn": "Reject",
    "approvedBanner": "Changes approved — title is live",
    "actionHint": "Approving applies these edits; the title stays approved and goes live.",
    "kbNav": "jump between changes",
    "kbApprove": "approve",
    "tags": {
      "added": "Added",
      "changed": "Changed",
      "removed": "Removed",
      "file": "File"
    },
    "reject": {
      "title": "Reject & return to publisher",
      "subtitle": "Add a note explaining what needs to change. The publisher will see this and can resubmit.",
      "placeholder": "Explain what needs revising before this can be approved…",
      "quick": [
        "Cover image failed validation",
        "Page count needs verification",
        "Synopsis too short",
        "Restore removed subject"
      ],
      "cancel": "Cancel",
      "send": "Send rejection"
    },
    "history": {
      "title": "Revision history",
      "count": "past revisions",
      "approved": "Approved",
      "rejected": "Rejected",
      "reviewedBy": "Reviewed by"
    },
    "fields": {
      "title": "Title",
      "arabicTitle": "Arabic title",
      "isbn13": "ISBN-13",
      "isbn10": "ISBN-10",
      "language": "Language",
      "coverPaperType": "Cover paper",
      "yearOfPublication": "Publication year",
      "edition": "Edition",
      "pages": "Pages",
      "authors": "Authors",
      "subjects": "Subjects",
      "bindingTypes": "Binding types",
      "distributionChannels": "Distribution channels",
      "interiorPaperType": "Interior paper",
      "synopsis": "Synopsis",
      "arabicSynopsis": "Arabic synopsis",
      "manuscript": "Manuscript PDF",
      "coverArtwork": "Cover artwork",
      "coverImage": "Cover image",
      "publisherName": "Publisher",
      "contributors": "Contributors",
      "coverType": "Cover type",
      "interiorColour": "Interior colour",
      "ageGroup": "Age group",
      "educationalStage": "Educational stage",
      "category": "Category",
      "keywords": "Keywords",
      "price": "Price",
      "copiesAvailableShipping": "Copies available for shipping",
      "returnsCount": "Returns count",
      "unsoldCopies": "Unsold copies",
      "datePublished": "Date published"
    }
  },
  "publishers": {
    "title": "Publishers",
    "subtitle": "Manage all registered publishers on the platform",
    "adminSectionLabel": "Management",
    "searchPlaceholder": "Search publishers, companies…",
    "footerLabel": "publishers",
    "export": "Export",
    "tabs": {
      "all": "All",
      "waiting": "Waiting",
      "current": "Current",
      "suspended": "Suspended"
    },
    "fields": {
      "publisher": "Publisher",
      "email": "Email",
      "country": "Country",
      "location": "Location",
      "registeredAt": "Registered",
      "registered": "Registered",
      "status": "Status",
      "actions": "Actions",
      "suspend": "Suspend",
      "organization": "Organization"
    },
    "status": {
      "waiting": "Waiting",
      "rejected": "Rejected",
      "accepted": "Active",
      "approved": "Approved",
      "pending": "Pending",
      "suspended": "Suspended"
    },
    "actions": {
      "approve": "Approve",
      "reject": "Reject",
      "restore": "Restore",
      "activate": "Activate",
      "noAction": "No action",
      "retry": "Retry",
      "select": "Select publisher",
      "selectAll": "Select all publishers",
      "suspendSuccess": "Publisher suspended successfully",
      "suspendError": "Failed to suspend publisher",
      "reactivateSuccess": "Publisher reactivated successfully",
      "reactivateError": "Failed to reactivate publisher",
      "view": "View details"
    },
    "empty": {
      "waiting": "No publishers awaiting approval",
      "current": "No active publishers yet",
      "suspended": "No suspended publishers"
    },
    "errors": {
      "loadFailed": "Failed to load publishers. Please try again."
    },
    "sectionLabel": "Publishing"
  },
  "dashboard": {
    "title": "Admin Dashboard",
    "subtitle": "Platform performance overview",
    "eyebrow": "Platform Overview",
    "welcome": "Welcome back",
    "exportReport": "Export report",
    "fields": {
      "title": "Title",
      "publisher": "Publisher",
      "status": "Status",
      "waiting": "Waiting",
      "actions": "Actions",
      "dateAdded": "Date Added"
    },
    "recentTitles": "Recent Titles",
    "workProgress": "Work Progress",
    "viewAll": "View All",
    "viewAllN": "View all {{count}} →",
    "export": "Export",
    "newTitle": "New Title",
    "status": {
      "published": "Published",
      "draft": "Draft",
      "pending": "Pending"
    },
    "progress": {
      "coverDesign": "Cover Design",
      "contentReview": "Content Review",
      "pdfPreparation": "PDF Preparation",
      "ftpTransfer": "FTP Transfer to Retailers"
    },
    "kpi": {
      "totalPublishers": "Total publishers",
      "activeInactive": "{{active}} active · {{inactive}} inactive",
      "totalTitles": "Total titles"
    },
    "submissionActivity": "Submission Activity",
    "chart": {
      "titlesAdded": "Titles added",
      "publishersAdded": "Publishers added",
      "period6m": "6 mo",
      "period3m": "3 mo"
    },
    "breakdown": {
      "perPlan": "Publishers per plan",
      "byCategory": "Titles by category",
      "byAgeGroup": "Titles by age group",
      "topPublishers": "Top publishers",
      "empty": "No data yet"
    },
    "plan": {
      "basic": "Basic",
      "standard": "Standard",
      "premium": "Premium",
      "enterprise": "Enterprise",
      "none": "No plan"
    },
    "approvalQueue": {
      "title": "Approval Queue",
      "pending": "{{n}} pending",
      "viewAll": "View all",
      "viewAllN": "View all {{n}} →",
      "sortedNote": "Sorted oldest first — most urgent at top",
      "approve": "Approve",
      "review": "Review"
    },
    "waiting": {
      "urgent": "{{days}}d — urgent",
      "mid": "{{days}}d — review soon",
      "ok": "{{days}}d"
    }
  },
  "stats": {
    "activeTitles": "Active Titles",
    "activeTitlesDelta": "3 this month",
    "manuscripts": "Manuscripts",
    "manuscriptsDelta": "2 pending review",
    "filesProcessing": "Files Processing",
    "filesProcessingDelta": "2 today",
    "users": "Users",
    "usersDelta": "Admin + 2 editors"
  },
  "sidebar": {
    "dashboard": "Dashboard",
    "titles": "Titles",
    "publishers": "Publishers",
    "manuscripts": "Manuscripts",
    "covers": "Book Covers",
    "ftp": "FTP Export",
    "users": "Users",
    "settings": "Settings",
    "logout": "Logout",
    "sectionDashboard": "Content",
    "management": "Management",
    "adminPanel": "Admin Panel"
  },
  "enterprise": {
    "sectionLabel": "Billing",
    "title": "Enterprise Plans",
    "subtitle": "Provision custom enterprise deals and manage title quotas.",
    "provisionTitle": "Provision enterprise",
    "provisionSubtitle": "Create a custom enterprise subscription and send the publisher a checkout link.",
    "updateQuotaTitle": "Update enterprise quota",
    "updateQuotaSubtitle": "Re-cap the title quota for an existing enterprise publisher.",
    "publisher": "Publisher",
    "publisherPlaceholder": "Select a publisher",
    "interval": "Billing interval",
    "monthly": "Monthly",
    "annual": "Annual",
    "amount": "Amount (USD)",
    "amountPlaceholder": "e.g. 499",
    "titleQuota": "Title quota",
    "titleQuotaPlaceholder": "e.g. 250",
    "unlimited": "Unlimited",
    "provision": "Provision",
    "provisioning": "Provisioning…",
    "updateQuota": "Update quota",
    "updatingQuota": "Updating…",
    "checkoutLink": "Checkout link",
    "checkoutLinkHelp": "Send this link to the publisher to complete payment.",
    "copy": "Copy",
    "copied": "Copied",
    "copyFailed": "Could not copy the link. Copy it manually.",
    "provisionSuccess": "Enterprise deal provisioned. Share the checkout link below.",
    "provisionError": "Could not provision the enterprise deal. Please try again.",
    "quotaSuccessLimited": "Quota updated to {{count}} titles.",
    "quotaSuccessUnlimited": "Quota updated to unlimited titles.",
    "quotaError": "Could not update the quota. Please try again.",
    "amountError": "Enter an amount greater than 0.",
    "checkoutResultTitle": "Checkout link for {{publisher}}",
    "checkoutResultSummary": "{{interval}} · {{quota}} · send this to the publisher to complete payment.",
    "checkoutQuotaUnlimited": "Unlimited titles",
    "checkoutQuotaCount": "{{count}} titles"
  },
  "toast": {
    "undo": "Undo",
    "dismiss": "Dismiss"
  },
  "profileSectionLabel": "Account",
  "profileTitle": "Profile",
  "profileSubtitle": "Your admin account details",
  "profileNotFound": "Unable to load profile.",
  "email": "Email",
  "role": "Role",
  "roleAdmin": "Admin",
  "roleUser": "User",
  "status": "Status",
  "publisherId": "Publisher ID",
  "comingSoon": {
    "title": "Coming Soon",
    "description": "This page is under development."
  },
  "titles": {
    "pageTitle": "Title Approvals",
    "pageSubtitle": "Review and approve or reject publisher titles",
    "tabs": {
      "pending": "Pending Review",
      "active": "Active",
      "all": "All"
    },
    "fields": {
      "title": "Title",
      "publisher": "Publisher",
      "isbn": "ISBN",
      "submitted": "Submitted",
      "actions": "Actions",
      "language": "Language",
      "pageCount": "Page Count"
    },
    "searchPlaceholder": "Search by title, author, or ISBN...",
    "emptyTitle": "No titles found",
    "emptyDesc": "No titles in this category",
    "loadError": "Failed to load titles",
    "count": "{{count}} title(s)",
    "review_button": "Review",
    "approve_button": "Approve",
    "reject_button": "Reject",
    "close_panel": "Close panel",
    "isbn_manual_entry": "Manual entry",
    "printSpecs": "Print Specifications",
    "printSpecsPaperType": "Paper Type",
    "printSpecsTrimSize": "Trim Size",
    "printSpecsBinding": "Binding",
    "printSpecsLamination": "Lamination",
    "printSpecsSpecialFinish": "Special Finish",
    "printSpecsCoverType": "Cover Type",
    "reject_modal_title": "Reject: {{title}}",
    "reject_modal_desc": "Please provide a reason for rejection.",
    "reject_reason_label": "Message to publisher",
    "reject_reason_optional": "optional",
    "reject_reason_placeholder": "What should the publisher fix before resubmitting? (optional)",
    "reject_reason_help": "Shared with the publisher and shown in their portal.",
    "reject_empty_confirm_title": "Reject without a reason?",
    "reject_empty_confirm_desc": "The publisher won’t be told what to change — only that the title was returned.",
    "reject_add_reason_button": "Add a reason",
    "reject_anyway_button": "Reject anyway",
    "cancel_button": "Cancel",
    "reject_confirm_button": "Reject Title",
    "toast_approved": "Title approved successfully",
    "toast_rejected": "Title rejected successfully",
    "toast_error": "An error occurred. Please try again.",
    "kpi_total": "Total Titles",
    "kpi_pending": "Pending Review",
    "kpi_approved": "Approved",
    "kpi_editing": "Editing",
    "panel_title_review": "Review Title",
    "actions": {
      "view": "View",
      "approve": "Approve",
      "reject": "Reject",
      "suspend": "Suspend",
      "reactivate": "Reactivate",
      "delete": "Delete",
      "activate": "Activate",
      "deactivate": "Deactivate"
    }
  },
  "close": "Close",
  "editPublisher": "Edit Publisher",
  "loading": "Loading...",
  "contactPerson": "Contact Person",
  "recentTitles": "Recent Titles",
  "account": "Account",
  "defaultRoyalty": "Default Royalty",
  "notes": "Notes",
  "totalTitles": "Total Titles",
  "drafts": "Drafts",
  "contactInfo": "Contact Info",
  "internalCode": "Internal Code",
  "contractRef": "Contract Reference",
  "adminOnly": "Admin Only",
  "admin": "Admin",
  "joined": "Joined",
  "address": "Address",
  "phone": "Phone",
  "website": "Website",
  "contact": "Contact",
  "inCatalogue": "In Catalogue",
  "noTitles": "No titles found",
  "titleColumn": "Title",
  "back": "Back",
  "backToPublishers": "Back to Publishers",
  "publisher_not_found": "Publisher not found",
  "editing": "Editing",
  "saveChanges": "Save Changes",
  "discard": "Discard",
  "editBtn": "Edit",
  "suspend": "Suspend",
  "saving": "Saving...",
  "catalogue": "Catalogue",
  "pages": "Pages",
  "added": "Date Added",
  "pending": "Pending",
  "published": "Published",
  "publisher": "Publisher",
  "edit": {
    "publisherIdentity": "Publisher Identity",
    "arabicName": "Arabic Name",
    "englishName": "English Name",
    "internalNotes": "Internal Notes",
    "companyName": "Company Name",
    "fullName": "Full Name",
    "country": "Country",
    "countryPlaceholder": "Select country",
    "taxNumber": "Tax Number",
    "account": "Account",
    "savedSuccessfully": "Publisher saved successfully",
    "status": "Status"
  },
  "settings": {
    "sectionLabel": "Account & Preferences",
    "pageTitle": "Settings",
    "pageSubtitle": "Manage your notification, language, and display preferences",
    "notifications": {
      "sectionTitle": "Notifications",
      "webPush": {
        "label": "Web Push",
        "description": "Browser push notifications"
      },
      "emailPush": {
        "label": "Email",
        "description": "Email-based notifications"
      },
      "testPush": "Test Push",
      "testPushDone": "Sent!",
      "testEmail": "Test Email",
      "testEmailDone": "Sent!",
      "statusDenied": "Blocked — reset via address bar 🔒 icon"
    },
    "language": {
      "sectionTitle": "Language",
      "rowLabel": "Language",
      "arCurrent": "Arabic (current)",
      "enCurrent": "English (current)"
    },
    "appearance": {
      "sectionTitle": "Appearance",
      "rowLabel": "Appearance",
      "lightDescription": "Light mode",
      "darkDescription": "Dark mode",
      "systemDescription": "Follow system",
      "light": "Light",
      "dark": "Dark",
      "system": "System"
    }
  },
  "mobile": {
    "of": "of",
    "view": "View",
    "edit": "Edit",
    "delete": "Delete",
    "language": "Language",
    "pages": "Pages",
    "isbn": "ISBN",
    "email": "Email",
    "website": "Website",
    "tradingAs": "Trading as",
    "primaryContact": "Primary contact",
    "total": "Total",
    "published": "Published",
    "pipeline": "Pipeline",
    "emptyTitle": "No titles match",
    "emptyDesc": "Try a different status filter, or clear filters to see every title.",
    "emptyPublishersTitle": "No publishers match",
    "emptyPublishersDesc": "Try a different status filter, or clear filters to see every publisher.",
    "showAll": "Show all titles",
    "showAllPublishers": "Show all publishers"
  },
  "adminLegal": {
    "sectionLabel": "Management",
    "title": "Legal Documents",
    "subtitle": "Author and publish Terms of Service and Privacy Policy versions.",
    "newVersion": "New version",
    "searchPlaceholder": "Search by title, summary, or version (e.g. v1)…",
    "footerOf": "of",
    "deleteConfirm": "Delete this draft? This cannot be undone.",
    "notFound": "Document not found.",
    "versionShort": "v{{version}}",
    "tabs": {
      "all": "All",
      "draft": "Drafts",
      "published": "Published",
      "archived": "Archived"
    },
    "filters": {
      "allTypes": "All types",
      "allLanguages": "All"
    },
    "docType": {
      "terms": "Terms of Service",
      "privacy": "Privacy Policy"
    },
    "language": {
      "ar": "Arabic",
      "en": "English"
    },
    "columns": {
      "title": "Title",
      "docType": "Type",
      "language": "Language",
      "version": "Version",
      "status": "Status",
      "effectiveAt": "Effective",
      "publishedAt": "Published"
    },
    "actions": {
      "view": "View",
      "edit": "Edit",
      "delete": "Delete",
      "cancel": "Cancel",
      "saveDraft": "Save draft",
      "saving": "Saving…",
      "publishNow": "Publish now",
      "publishing": "Publishing…",
      "unpublish": "Unpublish",
      "unpublishing": "Unpublishing…",
      "preview": "Preview",
      "createNewVersion": "New version"
    },
    "editor": {
      "source": "Source",
      "history": "History",
      "saveDraft": "Save draft",
      "inSync": "In sync",
      "current": "Current",
      "versions": "Version History",
      "versionsCount_one": "{{count}} version",
      "versionsCount_other": "{{count}} versions",
      "closeHistory": "Close history",
      "openVersion": "Open version {{version}}",
      "saveNote": "Save note",
      "noNote": "No note",
      "staleTranslation": "This translation may be out of date. Consider updating it to match the source.",
      "unsavedSwitchConfirm": "You have unsaved changes. Switch language and discard them?",
      "tabs": {
        "missing": "Missing",
        "stale": "Stale"
      },
      "publishModal": {
        "title": "Publish document",
        "notifications": "Notifications",
        "emailPublishers": "Notify publishers by email",
        "emailPublishersDesc": "Send an email to all active publishers when this version goes live.",
        "statusNow": "This version will go live immediately.",
        "confirmNow": "Publish now"
      }
    },
    "empty": {
      "title": "No documents match",
      "desc": "Try a different filter, or clear filters to see every document.",
      "showAll": "Show all"
    },
    "meta": {
      "sectionLabel": "Metadata",
      "docType": "Type",
      "language": "Language",
      "version": "Version",
      "effectiveAt": "Effective at",
      "publishedAt": "Published at",
      "createdBy": "Author",
      "created": "Created",
      "updated": "Updated",
      "changeSummary": "Change summary",
      "changeSummaryPlaceholder": "What changed in this version?",
      "changeSummaryHelp": "Shown to publishers when this version is published."
    },
    "edit": {
      "back": "Back to legal documents",
      "createEyebrow": "New version",
      "editEyebrow": "Editing v{{version}}",
      "untitledDoc": "Untitled document",
      "docType": "Document type",
      "language": "Language",
      "docTitle": "Document title",
      "docTitlePlaceholder": "e.g. Terms of Service",
      "contentPlaceholder": "Write the document content in Markdown…",
      "previewLabel": "Live preview",
      "previewEmpty": "Start typing to see a live preview."
    },
    "deleteDialogTitle": "Delete Document"
  },
  "language": "Language",
  "view": "View",
  "common": {
    "errors": {
      "generic": "An error occurred. Please try again."
    }
  },
  "publisherStatus": {
    "approved": "Active",
    "pending": "Pending",
    "suspended": "Suspended"
  }
}
